export * from '@fhs/routing/src/routes/v2/signin/signup';
export { default } from '@fhs/routing/src/routes/v2/signin/signup';
